import React from "react";
import "./Analytics.css";

// Renders the response envelope's `warning` field (e.g. "charge_details table
// is empty. Run POST /trigger-sync first.") as a banner instead of leaving a
// dashboard blank with no explanation.
const WarningBanner = ({ warning }) => {
  if (!warning) return null;
  return (
    <div className="analytics-warning-banner" role="status">
      {warning}
    </div>
  );
};

export default WarningBanner;
